import React from 'react';

export const Directors_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>DIRECTORS</span>,
  },
];

export const Director_Nuno = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>NUNO</em>
        <br />
        <strong>GÓMES</strong>
      </span>
    ),
  },
];

export const Director_Bernardo = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>BERNARDO</em>
        <br />
        <strong>VÁZQUEZ</strong>
      </span>
    ),
  },
];

export const Director_Maria = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>MARÍA JOSÉ</em>
        <br />
        <strong>NORIEGA</strong>
      </span>
    ),
  },
];

export const Director_Carlos = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>CARLOS</em>
        <br />
        <strong>MORETT</strong>
      </span>
    ),
  },
];

export const Director_Rodrigo = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>RODRIGO</em>
        <br />
        <strong>ROBLES</strong>
      </span>
    ),
  },
];

export const Text_Nuno = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Nuno Góme is a screenwriter, producer, and director based between Miami
        and Los Angeles, with a track record of 390+ projects across music
        videos, commercials, and narrative content. His work includes two Latin
        Grammy nominations, over 8 billion YouTube views, and collaborations
        with top-tier international artists. He has directed 150+ commercials
        for brands such as Pepsi, Gatorade, HBO Brasil, and Spectrum Mobile, and
        is the creator of two original series for Disney+.
      </span>
    ),
  },
];

export const TextVideo1_Nuno = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>DADDY YANKEE X JUSTIN QUILES X DALEX - "LA HORA Y EL DIA"</span>
    ),
  },
];

export const TextVideo2_Nuno = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>LEONEL GARCÍA - "SÁLVANOS"</span>,
  },
];

export const TextVideo3_Nuno = [
  {
    textSize: '0.813rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>CARIN LEÓN X ALEJANDRO FERNÁNDEZ - “ME ESTÁ DOLIENDO”</span>
    ),
  },
];

export const TextVideo4_Nuno = [
  {
    textSize: '0.813rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>OZUNA x TOKISCHA - "SOMOS IGUALES"</span>,
  },
];

export const Text_Maria = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        María José Noriega is a producer and director, and part of the Lucky
        Twins Films team. Her work focuses on the development and execution of
        audiovisual projects with a strong narrative vision and carefully
        crafted production, contributing to commercial and cinematic content
        that prioritizes storytelling, aesthetics, and on-set efficiency.
      </span>
    ),
  },
];

export const TextVideo1_Maria = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PUMA - Jersey Alternativo Rayados</span>,
  },
];

export const TextVideo2_Maria = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Cicatrices</span>,
  },
];

export const TextVideo3_Maria = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRITY</span>,
  },
];

export const TextVideo4_Maria = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>MODA</span>,
  },
];

export const Text_Bernardo = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Bernardo Vázquez is a Mexican director with a strong focus on aesthetics
        and a deep passion for cinematic language. In a short time, he has drawn
        attention within the industry. He began his career directing music
        videos, has experience directing children, and has created commercials
        for beauty and personal care products—particularly in hair-focused work.
      </span>
    ),
  },
];

export const TextVideo1_Bernardo = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CHARLY</span>,
  },
];

export const TextVideo2_Bernardo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>UNIFIN</span>,
  },
];

export const TextVideo3_Bernardo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>HARLEY DAVIDSON</span>,
  },
];

export const TextVideo4_Bernardo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PINEDA COVELIN</span>,
  },
];

export const Text_Carlos = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Carlos Morett is a director with experience across film and advertising,
        with a career spanning Mexico, Spain, and the United States. He directed
        the Netflix original feature film La Rebelión de los Godínez (2020),
        produced by Corazón Films, and has delivered campaigns for brands such
        as Pepsi, Coca-Cola, Cinemex, and the NFL. His profile combines
        narrative direction, commercial vision, and strategic execution.
      </span>
    ),
  },
];

export const TextVideo1_Carlos = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>MICTLÁN</span>,
  },
];

export const TextVideo2_Carlos = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Mutiny of the Worker Bees</span>,
  },
];

export const TextVideo3_Carlos = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>POPCON</span>,
  },
];

export const TextVideo4_Carlos = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>COCA-COLA</span>,
  },
];

export const Text_Rodrigo = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Rodrigo Robles Joseph is a director with a cinematic approach,
        specializing in commercial and institutional pieces driven by clear
        storytelling, rhythm, and atmosphere. His work stands out for a clean,
        emotionally resonant visual language, with meticulous attention to
        detail from concept through production. His piece “Tequila Solarum –
        Leyenda” was selected as a finalist nominee at the 27th Pantalla de
        Cristal Festival (2025).
      </span>
    ),
  },
];

export const TextVideo1_Rodrigo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>Mon Laferte, Alejandro Fernández - Que Se Sepa Nuestro Amor</span>
    ),
  },
];

export const TextVideo2_Rodrigo = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Salón Acapulco - Jamba Jamba</span>,
  },
];

export const TextVideo3_Rodrigo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>inter.mx</span>,
  },
];

export const TextVideo4_Rodrigo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Tequila Código 1530</span>,
  },
];
